import { EpicGroupTypesEnum } from './useTypeOptions';

type TagColorType = {
  [key: string]: string;
};

export const useTagColor = (type: string) => {
  const colorfulTags: TagColorType = {
    [EpicGroupTypesEnum.Products]: 'cyan',
    [EpicGroupTypesEnum.CostTypes]: 'volcano',
  };

  return colorfulTags[type] ?? 'default';
};
